import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import { Button } from "@/components/ui/button";
import { 
  Search,
  Home, 
  TrendingUp, 
  Calculator, 
  Activity, 
  Bell, 
  Settings,
  Command
} from "lucide-react";

const commands = [
  {
    group: "Navigation",
    items: [
      { id: "overview", title: "Overview", description: "Dashboard geral", icon: Home, route: "/app/overview" },
      { id: "markets", title: "Markets", description: "Análise de mercado", icon: TrendingUp, route: "/app/markets" },
      
      { id: "valuation", title: "Valuation", description: "Avaliação de ativos", icon: Calculator, route: "/app/valuation" },
      { id: "alpha", title: "Alpha On-Chain", description: "Dados on-chain", icon: Activity, route: "/app/alpha-onchain" },
      { id: "alerts", title: "Alerts", description: "Gerenciar alertas", icon: Bell, route: "/app/alerts" },
      { id: "settings", title: "Settings", description: "Configurações", icon: Settings, route: "/app/settings" },
    ]
  }
];

export const CommandMenu = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (e.key === "k" && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setOpen((open) => !open);
      }
    };

    document.addEventListener("keydown", down);
    return () => document.removeEventListener("keydown", down);
  }, []);

  const handleSelect = (route: string) => {
    setOpen(false);
    navigate(route);
  };

  return (
    <>
      {/* Mobile: compact icon button */}
      <Button
        variant="ghost"
        size="icon"
        className="md:hidden h-9 w-9"
        onClick={() => setOpen(true)}
      >
        <Search className="h-4 w-4" />
      </Button>
      
      {/* Desktop: full search bar */}
      <Button
        variant="outline"
        className="relative h-9 w-full justify-start rounded-[0.5rem] bg-background text-sm font-normal text-muted-foreground shadow-none sm:pr-12 md:w-80 lg:w-96 hidden md:inline-flex"
        onClick={() => setOpen(true)}
      >
        <Search className="mr-2 h-4 w-4" />
        <span className="hidden lg:inline-flex">Buscar páginas...</span>
        <span className="inline-flex lg:hidden">Buscar...</span>
        <kbd className="pointer-events-none absolute right-[0.3rem] top-[0.3rem] hidden h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium opacity-100 sm:flex">
          <span className="text-xs">⌘</span>K
        </kbd>
      </Button>
      
      <CommandDialog open={open} onOpenChange={setOpen}>
        <CommandInput placeholder="Digite um comando ou busque..." />
        <CommandList>
          <CommandEmpty>Nenhum resultado encontrado.</CommandEmpty>
          {commands.map((group) => (
            <CommandGroup key={group.group} heading={group.group}>
              {group.items.map((item) => {
                const IconComponent = item.icon;
                return (
                  <CommandItem
                    key={item.id}
                    onSelect={() => handleSelect(item.route)}
                    className="cursor-pointer"
                  >
                    <IconComponent className="mr-2 h-4 w-4" />
                    <div className="flex flex-col">
                      <span>{item.title}</span>
                      <span className="text-xs text-muted-foreground">
                        {item.description}
                      </span>
                    </div>
                  </CommandItem>
                );
              })}
            </CommandGroup>
          ))}
        </CommandList>
      </CommandDialog>
    </>
  );
};